import RoomEvent from '../../event/RoomEvent'
import AppDispatcher from '../../core/AppDispatcher'

const onEdit = (oldRoom, e) => {
  AppDispatcher.dispatchWithType(RoomEvent.onEdit, { name: e.target.name, value: e.target.value })
}

export default onEdit
